export const updateFileUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  filePath,
  content,
}) => {
  try {
    const freshToken = await getFreshToken();
    const response = await fetch(getEndpointUrl() + "/updateFile", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${freshToken}`,
      },
      body: JSON.stringify({ filePath, content }),
    });

    if (!response.ok) throw new Error("Error updating the file.");

    console.log(`File at ${filePath} updated successfully.`);
    return response;
  } catch (error) {
    console.error("Error updating file:", error);
    throw error;
  }
};
